"use strict";

var _typeof = require("/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gtmMetricsSubscriber;
var _utils = require("@sm/utils");
var _helpers = require("../helpers");
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function gtmMetricsSubscriber(digitalDataEvent) {
  var data = digitalDataEvent.data,
    name = digitalDataEvent.name;
  var actionType = data.actionType,
    actionFlow = data.actionFlow;
  if (!actionType || !actionFlow) {
    return;
  }

  // flatten the data object
  var gtmDataLayer = _objectSpread(_objectSpread({}, data), data.data);
  delete gtmDataLayer.data;
  var envDetails = (0, _utils.getClientEnvironmentDetails)();
  if (envDetails.isBrowser) {
    var pagePath = window.location.pathname;
    window.dataLayer = window.dataLayer || [];
    var eventObj = function eventObj(_ref) {
      var hasGDPRConsent = _ref.hasGDPRConsent,
        userId = _ref.userId,
        packageId = _ref.packageId,
        email = _ref.email,
        countryCode = _ref.countryCode;
      return {
        PAGE_VIEW: {
          event: 'pageView',
          loadMarketingContainer: hasGDPRConsent,
          user_id: userId,
          package_id: packageId,
          email: (0, _helpers.maskEmail)(email),
          country_code: countryCode
        },
        VIRTUAL_PAGE_VIEW: {
          event: 'virtualPageView',
          virtualPageUrl: pagePath,
          virtualPageTitle: actionFlow
        },
        GDPR_ACTION: {
          event: actionFlow,
          loadMarketingContainer: actionFlow !== 'denyConsent'
        }
      };
    };
    var gtm = eventObj(gtmDataLayer)[actionType] || _objectSpread({
      event: name
    }, gtmDataLayer);
    if (Object.keys(gtm).length) {
      window.dataLayer.push(gtm);
    }
  }
}
module.exports = exports.default;